<template>
  <div>
    <delete-documents-modal
        v-if="selectedFromActiveCategory"
        @close="onCloseDeleteModal"
        :category="category"
    >
    </delete-documents-modal>
    <attachable-move-modal
        :attachables="selectedFromActiveCategory"
        :customer-id="customerId"
        :has-attachable-type="hasAttachableType"
        :has-attachable-id="hasAttachableId"
        :category="category"
        :visible="showMoveModal"
        v-on:close="onCloseMoveModal"
        v-on:complete="onCompleteMoveModal"></attachable-move-modal>
    <attachable-copy-modal
        v-if="selectedFromActiveCategory"
        :attachables="selectedFromActiveCategory"
        :customer-id="customerId"
        :has-attachable-type="hasAttachableType"
        :has-attachable-id="hasAttachableId"
        :category="category"
        :visible="showCopyModal"
        v-on:close="onCloseCopyModal"></attachable-copy-modal>
  </div>
</template>

<script>
import DeleteDocumentsModal from './DeleteDocumentsModal.vue';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
export default {
  name: "DocumentModals.vue",
  computed: {
    ...mapState(`$_attachable_widget`, {
      hasAttachableType: 'hasAttachableType',
      hasAttachableId: 'hasAttachableId',
      category: 'category',
      showCopyModal: 'showCopyModal',
      showMoveModal: 'showMoveModal',
      showDeleteModal: 'showDeleteModal',
      customerId: 'customerId',
      selectedAttachables: 'selectedAttachables',
    }),
    ...mapGetters(`$_attachable_widget`, {
      selectedFromActiveCategory: 'selectedFromActiveCategory',
    })
  },
  components: {
    DeleteDocumentsModal
  },
  methods: {
    onCloseMoveModal() {
      this.setShowMoveModal(false);
    },
    onCompleteMoveModal() {
      this.setShowMoveModal(false);
      this.getAttachableCategories();
      this.deleteSelectedAttachablesFromState();
      this.setSelectedAttachables({attachables: [], id: this.category.id});
    },
    onCloseCopyModal() {
      this.setShowCopyModal(false);
    },
    onCloseDeleteModal() {
      this.setShowDeleteModal(false);
      this.setSelectedAttachables({attachables: [], id: this.category.id});
    },
    ...mapActions(`$_attachable_widget`, {
      getAttachableCategories: 'getAttachableCategories',
      deleteSelectedAttachablesFromState: 'deleteSelectedAttachablesFromState',
    }),
    ...mapMutations(`$_attachable_widget`, {
      setSelectedAttachables: 'SET_SELECTED_ATTACHABLES',
      setShowCopyModal: 'SET_SHOW_COPY_MODAL',
      setShowMoveModal: 'SET_SHOW_MOVE_MODAL',
      setShowDeleteModal: 'SET_SHOW_DELETE_MODAL',
    }),
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
